import { colors, spacing } from '@lamimed/pantheon';

import { Card } from './containers/Card';
import { ColumnRow } from './containers/ColumnRow';
import { ColumnRowView } from './containers/ColumnRowView';
import { Row } from './containers/Row';

import * as S from './styles';

export interface InfoBoxProps {
  borderColor?: keyof typeof colors;
  backgroundColor?: keyof typeof colors;
  hasBorder?: boolean;
  children: React.ReactNode;
  marginBottom?: keyof typeof spacing;
  marginTop?: keyof typeof spacing;
  padding?: keyof typeof spacing;
  minHeight?: string;
}

export const InfoBox = ({
  backgroundColor = 'light',
  hasBorder = true,
  borderColor = 'neutral_light',
  marginBottom = 'none',
  marginTop = 'medium',
  padding = 'small',
  minHeight = 'initial',
  children,
}: InfoBoxProps) => {
  return (
    <S.InfoBoxWrapper
      backgroundColor={backgroundColor}
      hasBorder={hasBorder}
      borderColor={borderColor}
      marginBottom={marginBottom}
      marginTop={marginTop}
      padding={padding}
      minHeight={minHeight}
    >
      {children}
    </S.InfoBoxWrapper>
  );
};

InfoBox.ColumnRow = ColumnRow;

InfoBox.ColumnRowView = ColumnRowView;

InfoBox.Row = Row;

InfoBox.Card = Card;
